import { useEffect, useRef } from 'react';

const useScrollReveal = (options = {}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const threshold = options.threshold || 0.15;
    const rootMargin = options.rootMargin || '0px 0px -40px 0px';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin }
    );

    const children = el.querySelectorAll('.reveal');
    children.forEach((child) => observer.observe(child));

    return () => observer.disconnect();
    // `options.key`: a page that swaps its content (e.g. a tab) passes the
    // current view, so the newly mounted `.reveal` elements are observed too.
  }, [options.threshold, options.rootMargin, options.key]);

  return ref;
};

export default useScrollReveal;
